import React from 'react'

import styles from './MultimediaButtonContent.module.css'

const iconStyles = { width: '3.5em', height: '3.5em' }

export type MultimediaButtonContentProps = {
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  title: string
  subtitle: string
}

const MultimediaButtonContent: React.FC<MultimediaButtonContentProps> = ({ Icon, title, subtitle }) => {
  return (
    <div>
      {Icon && <Icon style={iconStyles} />}
      <div>
        <span className={`font-body-medium-bold ${styles.title}`}>{title}</span>
      </div>
      <div>
        <span className={`font-body-small-regular ${styles.subtitle}`}>{subtitle}</span>
      </div>
    </div>
  )
}

export default MultimediaButtonContent
